import AdaptiveImage from "../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js";

export default new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/mobile.5bc1b221.png",
    width: 360,
    height: 216
});